export const environment = {
    production: false,
    appVersion: "0.0.1",
    serviceUrl: 'https://staging-femsecret-service-309951344271.us-central1.run.app',
    amplitudeKey: '8bdf57e106fcab3345183ef4f310e85a',
    stripePubKey: 'pk_test_51QTnamKDKGssBfMhVaPPZ9oJbm710nCh7mXn1adebIyHIyRdC4LYLG4lqCMMQVmxKPt9MkIWPgV6tGUK86tfWJhW00WESuX4H4',
};